// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IInitiateAuthRequestDto
 */
export interface IInitiateAuthRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IInitiateAuthRequestDto
     */
    user_name: string;
    /**
     * 
     * @type {string}
     * @memberof IInitiateAuthRequestDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof IInitiateAuthRequestDto
     */
    new_password?: string;
    /**
     * 
     * @type {string}
     * @memberof IInitiateAuthRequestDto
     */
    remember_me_device_token?: string;
    /**
     * 
     * @type {string}
     * @memberof IInitiateAuthRequestDto
     */
    client_type?: IInitiateAuthRequestDtoClientTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IInitiateAuthRequestDtoClientTypeEnum {
    WEB_APP = 'WEB_APP',
    MOBILE_APP = 'MOBILE_APP',
    PARTNER_SSO = 'PARTNER_SSO',
    MANAGE_PROFILE = 'MANAGE_PROFILE',
    FORGOT_PASSWORD = 'FORGOT_PASSWORD'
}


/**
 * Check if a given object implements the IInitiateAuthRequestDto interface.
 */
export function instanceOfIInitiateAuthRequestDto(value: object): value is IInitiateAuthRequestDto {
    if (!('user_name' in value) || value['user_name'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function IInitiateAuthRequestDtoFromJSON(json: any): IInitiateAuthRequestDto {
    return IInitiateAuthRequestDtoFromJSONTyped(json, false);
}

export function IInitiateAuthRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInitiateAuthRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'user_name': json['user_name'],
        'password': json['password'],
        'new_password': json['new_password'] == null ? undefined : json['new_password'],
        'remember_me_device_token': json['remember_me_device_token'] == null ? undefined : json['remember_me_device_token'],
        'client_type': json['client_type'] == null ? undefined : json['client_type'],
    };
}

export function IInitiateAuthRequestDtoToJSON(json: any): IInitiateAuthRequestDto {
    return IInitiateAuthRequestDtoToJSONTyped(json, false);
}

export function IInitiateAuthRequestDtoToJSONTyped(value?: IInitiateAuthRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_name': value['user_name'],
        'password': value['password'],
        'new_password': value['new_password'],
        'remember_me_device_token': value['remember_me_device_token'],
        'client_type': value['client_type'],
    };
}

